const RELOAD_KEY = "stale-chunk-reload-at";
const RELOAD_WINDOW_MS = 10_000;

const STALE_CHUNK_MESSAGES = [
  /Failed to fetch dynamically imported module/,
  /Importing a module script failed/,
  /Failed to load module script/,
  /is not a valid JavaScript MIME type/,
  /Unable to preload CSS for/,
];

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");

  return STALE_CHUNK_MESSAGES.some((pattern) => pattern.test(message));
}

// The sessionStorage guard stops a reload loop when an asset is genuinely gone.
export function reloadOnStaleChunk(error: unknown): boolean {
  if (!isStaleChunkError(error)) {
    return false;
  }

  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);

  if (Date.now() - lastReloadAt <= RELOAD_WINDOW_MS) {
    return false;
  }

  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();

  return true;
}
